import { Dialog, DialogContent, Box, Typography } from "@mui/material";
import { useState, useMemo } from "react";
import { useSetActionCall } from "../modules/services";

export default function EnvironmentSelector({
  open,
  onClose,
  environment = [],
  onSelect,
  sessionId,
}) {
  const { mutate: sendEnvironmentCall } = useSetActionCall();

  const defaultEnvironment = useMemo(() => {
    return environment.find((env) => env.is_default) || environment[0];
  }, [environment]);

  const [selectedId, setSelectedId] = useState(
    defaultEnvironment?.environment_id
  );

  const handleSelect = (env) => {
    setSelectedId(env.environment_id);
    onSelect?.(env);

    sendEnvironmentCall({
      message: {
        type: "change_environment",
        message: {
          environment_id: env.environment_id,
        },
      },
      session_id: sessionId,
    });
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 2,
          maxWidth: 250,
          m: 0,
          position: "fixed",
          bottom: 90,
          right: 20,
          top: "auto",
          left: "5%",
          transform: "none",
        },
      }}
      BackdropProps={{
        sx: {
          backgroundColor: "transparent",
        },
      }}
      sx={{
        "& .MuiDialog-container": {
          alignItems: "flex-end",
          justifyContent: "flex-end",
        },
      }}
    >
      <DialogContent>
        <Box
          sx={{
            display: "flex",
            gap: 1.5,
            background: "#fff",
            borderRadius: 1,
          }}
        >
          {environment.map((env) => {
            const isActive = selectedId === env.environment_id;

            return (
              <Box
                key={env.environment_id}
                onClick={() => handleSelect(env)}
                sx={{
                  width: 100,
                  height: 80,
                  borderRadius: "4px",
                  border: isActive ? "2px solid #002366" : "1px solid #ccc",
                  overflow: "hidden",
                  cursor: "pointer",
                  position: "relative",
                  boxShadow: isActive ? "0 0 4px #002366" : "none",
                  transition: "all 0.2s ease",
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <Box
                  component="img"
                  src={env.environment_icon}
                  alt={env.environment_name}
                  sx={{
                    width: "100%",
                    height: 55,
                    objectFit: "cover",
                  }}
                />
                <Typography
                  variant="caption"
                  sx={{
                    color: "#fff",
                    fontSize: "0.75rem",
                    fontWeight: 600,
                    textAlign: "center",
                    backgroundColor: "rgba(0,0,0,0.6)",
                    px: 1,
                    py: 0.5,
                  }}
                >
                  {env.environment_name}
                </Typography>
              </Box>
            );
          })}
        </Box>
      </DialogContent>
    </Dialog>
  );
}
